<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div class="">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="用户名称：">
              <el-input v-model="searchForm.name" placeholder="请输入用户昵称/手机号搜索" class="mt-search-width"></el-input>
            </el-form-item>
            <el-form-item label="是否充值：">
              <el-select v-model="searchForm.isRecharge" placeholder="请选择" class="mt-search-width">
                <el-option
                  v-for="item in isRechargeArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间筛选：">
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
              <el-button @click="exportExcelBtn" v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div>
        <el-table
          border
          :data="infoList"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="inviteNickName"
            label="老用户昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="invitePhone"
            label="老用户昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="新用户昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="新用户手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userCreateTime"
            label="注册时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="isRechargeLabel"
            label="是否充值">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rechargeDate"
            label="充值时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rechargeNo"
            label="充值单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rechargeMoney"
            label="充值金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="rewardMoney"
            label="奖励金额">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.rechargeStatus == 1" @click="sendUserBtn(scope.row.id)" type="text" size="small">发放</el-button>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryMinAppUserInviteLogPageList, orderExportExcel, processUserInviteLog } from '@/api/lx'
export default {
  name: 'LxRecord',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      isRechargeArr: [{
        value:99,
        label:'全部'
      },{
        value:0,
        label:'未充值'
      },{
        value:1,
        label:'已充值'
      }],
      searchForm: {
        name:'',
        isRecharge:'',
        date:['', '']
      },
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:''
    }
  },
  mounted () {
    var that = this;
    that.getInfoList();
  },
  created() {

  },
  methods: {
    // 发放
    sendUserBtn (infoId) {
      let that = this
      this.$confirm('确认发放吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        processUserInviteLog({ id: infoId}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 导出操作
    exportExcelBtn(){
      let that = this
      let isRecharge = that.searchForm.isRecharge == '' ? 99 : that.searchForm.isRecharge
      let searchName = that.searchForm.name
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      that.fullscreenLoading = true;
      orderExportExcel({webSearchStr: searchName,isRecharge: isRecharge, startRechargeDate: startDate, endRechargeDate: endDate}).then((res) => {
        that.fullscreenLoading = false;
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '拉新列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // 获取数据
    getInfoList () {
      let that = this
      let isRecharge = that.searchForm.isRecharge == '' ? 99 : that.searchForm.isRecharge
      let searchName = that.searchForm.name
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      queryMinAppUserInviteLogPageList({ webSearchStr: searchName,isRecharge: isRecharge, startRechargeDate: startDate, endRechargeDate: endDate, pageNum: page, pageSize: that.limitLength }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/lx/Record.vue